import useSWR from 'swr';
import { adminApi, type ApiUsageQuery } from '../lib/api';

// 30s refresh matches the existing platform-perf monitoring page.
const POLL_INTERVAL = 30_000;

// useSWR's auto-revalidation works best when the key is a stable string. We
// derive it once per params object so SWR caches per-filter (and dedupes
// concurrent calls between the summary/timeseries/breakdown hooks below).
function key(prefix: string, params: ApiUsageQuery | null, extra: string = '') {
  if (!params) return null;
  return `${prefix}?${params.from}|${params.to}|${params.organizationId || ''}|${params.userId || ''}|${params.apiKeyId || ''}|${params.path || ''}${extra}`;
}

export function useApiUsageSummary(params: ApiUsageQuery | null) {
  return useSWR(key('api-usage:summary', params), () => adminApi.getApiUsageSummary(params!), {
    refreshInterval: POLL_INTERVAL,
    revalidateOnFocus: false,
  });
}

export function useApiUsageTimeseries(
  params: (ApiUsageQuery & { granularity?: 'auto' | 'hour' | 'day' }) | null,
) {
  return useSWR(
    key('api-usage:timeseries', params, params?.granularity ? `|g=${params.granularity}` : ''),
    () => adminApi.getApiUsageTimeseries(params!),
    { refreshInterval: POLL_INTERVAL, revalidateOnFocus: false },
  );
}

export function useApiUsageByEndpoint(params: ApiUsageQuery | null) {
  return useSWR(key('api-usage:by-endpoint', params), () => adminApi.getApiUsageByEndpoint(params!), {
    refreshInterval: POLL_INTERVAL,
    revalidateOnFocus: false,
  });
}

export function useApiUsageByApiKey(params: ApiUsageQuery | null) {
  return useSWR(key('api-usage:by-api-key', params), () => adminApi.getApiUsageByApiKey(params!), {
    refreshInterval: POLL_INTERVAL,
    revalidateOnFocus: false,
  });
}

export function useApiUsageByOrg(params: ApiUsageQuery | null) {
  return useSWR(key('api-usage:by-org', params), () => adminApi.getApiUsageByOrg(params!), {
    refreshInterval: POLL_INTERVAL,
    revalidateOnFocus: false,
  });
}
